import { render, staticRenderFns } from "./UsernameInput.vue?vue&type=template&id=e036a4a2&"
import script from "./UsernameInput.vue?vue&type=script&lang=ts&"
export * from "./UsernameInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports